export default __webpack_public_path__ + "static/stadtwerke-karlsruhe-vector-logo-3b9b5bf92a328036d4b460799a7f3aed.svg";